import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import CalendarPage from './pages/CalendarPage';
import MatchPage from './pages/MatchPage';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import SetPasswordPage from './pages/SetPasswordPage';

export default function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/set-password" element={<SetPasswordPage />} />
      <Route path="/" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
      <Route path="/matches/:id" element={<ProtectedRoute><MatchPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute requiredRole="Admin"><AdminPage /></ProtectedRoute>} />
    </Routes>
  );
}
